import Vue from 'vue';

// 부모 - 자식이 아닌 컴포넌트간의 데이터 전송을 위한 eventBus
const EventBus = new Vue();

export default EventBus;
